import { styled } from "@mui/material";
import useBusinessInfoItems from "./businessInfoItems";
import { Form, Formik, useFormikContext } from "formik";
import { apiUpdateBussiness } from "api/businessApi";
import { useDispatch, useSelector } from "react-redux";
import UploadImageComponent from "components/Input/UploadImageComponent";
import { HeaderLogoPalceholder } from "./ProfileDetails";
import { SelectInput, TextInput } from "components/Input/FormControl";
import businessTypes from "assets/js/businessTypes";
import { Cities, States } from "constants/ProvincesList";
import { forwardRef, useImperativeHandle, useRef } from "react";

const MainContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
}));

const BusinessInfo = forwardRef((props, ref) => {
    const formRef: any = useRef();
    const dispatch = useDispatch();
    const businessInfoItems = useBusinessInfoItems();
    // @ts-ignore
    const businessState = useSelector((state) => state).businessReducer;
    // @ts-ignore
    // const taxRate = useSelector((state) => state).appReducer.appSettings.taxRate
    // @ts-ignore
    const fiscalYear = useSelector((state) => state).appReducer.fiscalYear;
    const businessInitialValues = { ...businessState?.business?.business, fiscalYearTitle: fiscalYear?.name, startDate: fiscalYear?.start_date, endDate: fiscalYear?.end_date,};
    const token = businessState?.business?.token;

    const updateSettingSubmit = (values: any) => {
        // @ts-ignore
        dispatch(apiUpdateBussiness(values, token));
    };

    const data: any = useFormikContext()?.values;
    let cities: any = Cities.filter((x) => x.stateId === 1);
    const state = data && data.state && States.find((x) => x.value === data.state);
    if (state) cities = Cities.filter((x) => x.stateId === state.id);

    useImperativeHandle(
        ref,
        () => {
            return {
                submit() {
                    if (formRef.current) {
                        formRef?.current?.handleSubmit();
                    }
                },
            };
        },
        []
    );

    return (
        <Formik
            innerRef={formRef}
            initialValues={businessInitialValues}
            onSubmit={updateSettingSubmit}
            enableReinitialize={true}
        >
            {(formik) => (
                <Form>
                    <div className="container flex flex-col">
                        <div className="flex flex-wrap items-center w-full gap-10 md:flex-nowrap">
                            <div className="flex justify-center w-full">
                                <div className="flex flex-col justify-center item-center">
                                    <span className="mb-4 text-center">لوگو کسب و کار</span>
                                    <UploadImageComponent
                                        rounded={true}
                                        name="businessAvatar"
                                        width={164}
                                        height={164}
                                        innerWidth={125}
                                        innerHeight={125}
                                        LogoPlaceholder={HeaderLogoPalceholder}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="flex flex-row justify-between gap-4">
                                    <TextInput required={true} name="nickName" label="نام کسب و کار" />
                                </div>
                                <div className="flex flex-row justify-between gap-4 mt-8 ">
                                    <SelectInput
                                        required={true}
                                        name="businessType"
                                        label="نوع کسب و کار"
                                        selectOption={businessTypes}
                                    />
                                    <TextInput required={true} label="زمینه فعالیت" name="fieldActivity" />
                                </div>
                            </div>
                        </div>
                        <div className="mt-16 mb-6">
                            <span className="text-sm text-dark-5">
                                درصورت استفاده از سامانه مودیان یا تمایل به ارائه فاکتور رسمی این قسمت را تکمیل کنید
                            </span>
                        </div>
                        <div>
                            <TextInput label="نام قانونی کسب و کار" name="legalName" />
                        </div>
                        <div className="flex flex-row justify-between gap-4 mt-10">
                            <TextInput label="شماره ثبت" name="registrationNumber" />
                            <TextInput label="شناسه ملی" name="nationalID" />
                            <TextInput label="کد اقتصادی" name="economicalCode" />
                            <SelectInput required={true} label="نوع صورتحساب مودیان" name="taxType" selectOption={[
                                //@ts-ignore
                                { id: 1, value: 'نوع اول', label: 'نوع اول' },
                                //@ts-ignore
                                { id: 2, value: 'نوع دوم', label: 'نوع دوم' },
                            ]} />
                        </div>

                        <div className="mt-16 ">
                            <span className="text-sm text-dark-5">آدرس</span>
                        </div>

                        <div className="flex flex-row justify-between gap-4 mt-6 ">
                            <SelectInput required={true} label="استان" name="state" selectOption={States} />
                            <SelectInput
                                required={true}
                                label="شهر"
                                name="city"
                                // @ts-ignore
                                selectOption={() => {
                                    const state = States.find((s) => s.value === formik.values.state);
                                    return Cities.filter((c) => c.stateId === state?.id);
                                }}
                            />
                        </div>
                        <div className="flex flex-row justify-between gap-4 mt-10">
                            <div className="flex w-2/3">
                                <TextInput label="آدرس" name="address" />
                            </div>
                            <div className="flex w-1/3">
                                <TextInput label="کدپستی" name="postalCode" />
                            </div>
                        </div>

                        <div className="mt-16 ">
                            <span className="text-sm text-dark-5">اطلاعات تماس</span>
                        </div>
                        <div className="flex flex-row justify-between gap-4 mt-6">
                            <TextInput label="وبسایت" name="webSite" />
                            <TextInput label="تلفن" name="phone" />
                            <TextInput label="فکس" name="fax" />
                            <TextInput label="همراه" name="mobile" />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
});

export default BusinessInfo;
